import { COLOR_PALETTE } from 'constants/ui';

export const sidebarStyles = {
  display: 'flex',
  flexDirection: 'column',
  width: '240px',
  minWidth: '240px',
  padding: '12px',
  borderRight: ({ palette }) => `1px solid ${palette.border.default}`,
  overflow: 'auto',
};

const sidebarItemStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 12px',
  borderRadius: '6px',
  cursor: 'pointer',
  transition: 'background-color 0.15s ease',

  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },
};

const activeSidebarItemStyles = {
  ...sidebarItemStyles,
  backgroundColor: COLOR_PALETTE.BRAND[1],

  '&:hover': {
    backgroundColor: COLOR_PALETTE.BRAND[2],
  },
};

const sidebarItemLabelStyles = {
  minWidth: 0,
  color: 'text.secondary',
};

const activeSidebarItemLabelStyles = {
  ...sidebarItemLabelStyles,
  color: COLOR_PALETTE.BRAND[7],
};

const dimmedSidebarItemLabelStyles = {
  ...sidebarItemLabelStyles,
  color: 'text.disabled',
};

const subGroupItemStyles = {
  ...sidebarItemStyles,
  paddingLeft: '28px',
};

const activeSubGroupItemStyles = {
  ...subGroupItemStyles,
  backgroundColor: COLOR_PALETTE.BRAND[1],

  '&:hover': {
    backgroundColor: COLOR_PALETTE.BRAND[2],
  },
};

const subGroupLabelStyles = {
  minWidth: 0,
  color: 'text.secondary',
};

const activeSubGroupLabelStyles = {
  ...subGroupLabelStyles,
  color: COLOR_PALETTE.BRAND[7],
};

const dimmedSubGroupLabelStyles = {
  ...subGroupLabelStyles,
  color: 'text.disabled',
};

export const expandIconStyles = {
  color: 'text.disabled',
  transition: 'transform 0.2s ease',
  marginLeft: '4px',
};

export const expandedIconStyles = {
  ...expandIconStyles,
  transform: 'rotate(180deg)',
};

export const sectionHeaderRowStyles = {
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
};

export const getItemStyles = (selectedSection, sectionKey) => {
  if (selectedSection === sectionKey) {
    return activeSidebarItemStyles;
  }

  return sidebarItemStyles;
};

export const getLabelStyles = (selectedSection, sectionKey, count) => {
  if (selectedSection === sectionKey) {
    return activeSidebarItemLabelStyles;
  }

  if (!count) {
    return dimmedSidebarItemLabelStyles;
  }

  return sidebarItemLabelStyles;
};

export const getLabelVariant = (selectedSection, sectionKey) => {
  if (selectedSection === sectionKey) {
    return 'bold14';
  }

  return 'medium14';
};

export const getSubItemStyles = (selectedSection, sectionKey) => {
  if (selectedSection === sectionKey) {
    return activeSubGroupItemStyles;
  }

  return subGroupItemStyles;
};

export const getSubLabelStyles = (selectedSection, sectionKey, count) => {
  if (selectedSection === sectionKey) {
    return activeSubGroupLabelStyles;
  }

  if (!count) {
    return dimmedSubGroupLabelStyles;
  }

  return subGroupLabelStyles;
};

export const getSubLabelVariant = (selectedSection, sectionKey) => {
  if (selectedSection === sectionKey) {
    return 'medium12';
  }

  return 'regular12';
};
